import React from "react";
import Image, { StaticImageData } from "next/image";

const Testimony = ({ imgSrc, index, name, age, desc }: { imgSrc: StaticImageData; index: number; name: string; age: string; desc: string }) => {
  return (
    <React.Fragment key={index}>
      <div className="testimony-card group relative border border-black/[0.08] rounded-2xl p-6 md:w-[420px] w-[300px] flex flex-col items-start space-y-4 text-start bg-white shadow-[0_2px_16px_rgba(0,0,0,0.04)] hover:shadow-[0_8px_32px_rgba(0,0,0,0.08)] hover:border-black/[0.12] transition-all duration-300 ease-out">
        {/* Decorative quote mark */}
        <span className="absolute top-4 right-5 text-5xl font-serif text-black/[0.06] select-none leading-none">"</span>

        <p className="text-[15px] leading-relaxed text-black/70 relative z-10 pr-6">
          {desc}
        </p>

        <div className="flex flex-row items-center space-x-3 pt-2 border-t border-black/[0.06] w-full">
          <Image
            width={44}
            height={44}
            loading="eager"
            src={imgSrc}
            alt={`${name}'s testimonial`}
            className="rounded-full ring-2 ring-black/[0.05]"
          />
          <div className="flex flex-col">
            <span className="text-sm font-semibold text-black/90">
              {name}
            </span>
            <span className="text-xs text-black/50">Age {age}</span>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Testimony;
